const getSourceOfWealthOptions = (t) => [
    {
        label: t('major_of_wealth_choice_1'),
        value: 'Allowances/Spousal Income',
    },
    {
        label: t('major_of_wealth_choice_2'),
        value: 'Investment Income',
    },
    {
        label: t('major_of_wealth_choice_3'),
        value: 'Properties',
    },
    {
        label: t('major_of_wealth_choice_4'),
        value: 'Inheritance/Gifts',
    },
    {
        label: t('major_of_wealth_choice_5'),
        value: 'Income from Employment',
    },
];

export default getSourceOfWealthOptions;
